import { useCallback } from 'react';

import { type Upload, uploadByIdSelector } from '@air/redux-uploader';

import { getUploadBoardIdFromStore } from '~/components/Upload/utils/getUploadBoardIdFromStore';
import { metadataForPrivateUploadSelector } from '~/store/privateUploadMetadata/selectors';
import { uploadingPathToBoardIdSelector } from '~/store/uploadingPathToBoardId/selector';
import { createPathRootId, getFileParentsPaths } from '~/store/uploadingPathToBoardId/utils';
import { useAirStore } from '~/utils/ReduxUtils';

export const useIsBlockedByParentBoard = () => {
  const store = useAirStore();

  const isBlockedByParentBoard = useCallback(
    (uploadId: Upload['id']) => {
      const nextUpload = uploadByIdSelector(store.getState(), uploadId);
      const pathToBoardId = uploadingPathToBoardIdSelector(store.getState());
      if (nextUpload) {
        const parentBoardId = getUploadBoardIdFromStore({ upload: nextUpload, store });
        const uploadMetadata = metadataForPrivateUploadSelector(store.getState(), uploadId);
        const pathRootId = createPathRootId(nextUpload.batchId, uploadMetadata?.originBoard?.id);

        if (!parentBoardId && uploadMetadata) {
          const parents = getFileParentsPaths(uploadMetadata.filepath);

          // check to see if any of the parent boards for the upload are being created
          return parents.some((path) => pathToBoardId?.[pathRootId]?.[path]?.isCreating);
        }
        return false;
      }
      return true;
    },
    [store],
  );

  return {
    isBlockedByParentBoard,
  };
};
